<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>Ball Park</title>
<link href="../styles/styles.css" rel="stylesheet" type="text/css"/>
<link href="../styles/additional.css" rel="stylesheet" type="text/css"/>
<h3 class="books-by-head1"><em>Recent titles by John Farrow</em></h3>
<p class="books-by-text1-space-after"><em>Émile Cinq-Mars thrillers</em></p>
<p class="books-by-text1">CITY OF ICE</p>
<p class="books-by-text1">ICE LAKE</p>
<p class="books-by-text1">RIVER CITY</p>
<p class="books-by-text1">THE STORM MURDERS</p>
<p class="books-by-text1">SEVEN DAYS DEAD</p>
<p class="books-by-text1">PERISH THE DAY</p>
<p class="books-by-text1-space-after">BALL PARK *</p>
<p> </p>
<p class="books-by-text1"><span class="small"><em>* available from Severn House</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// alsoby.vue?681573a3